import { $ } from "@/common/Axios";

export default {
  /**
   * 成教课表
   */
  adultCourseTable: {
    /*
     * 添加
     * endTime 结束时间 (string query )
     * id  (integer query )
     * majorId 专业id (integer query )
     * name 课程名称 (string query )
     * rollGrade 学籍年级 (string query )
     * startTime 开始时间 (string query )
     * teacher 任课老师 (string query )
     */
    post: (p, c) => $.post("/api/ems/study/adultCourseTable", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/study/adultCourseTable", p, c),
  },
  adultCourseTable_clear: {
    /*
     * 清空课表
     * endTime 结束时间 (string query required)
     * rollGrade 学籍年级 (string query required)
     * siteId 学校id (integer query required)
     * startTime 开始时间 (string query required)
     */
    delete: (p, c) => $.delete("/api/ems/study/adultCourseTable/clear", p, c),
  },
  adultCourseTable_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/study/adultCourseTable/export", p, c),
  },
  adultCourseTable_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/study/adultCourseTable/list", p, c),
  },
  adultCourseTable_listForClient: {
    /*
     * 客户端列表
     * startTime 开始时间（周一0点） (string query required)
     */
    get: (p, c) => $.get("/api/ems/study/adultCourseTable/listForClient", p, c),
  },
  adultCourseTable_platformInfo: {
    /*
     * 平台信息
     */
    get: (p, c) => $.get("/api/ems/study/adultCourseTable/platformInfo", p, c),
  },
  adultCourseTable_updatePlatformInfo: {
    /*
     * 更新平台信息
     * account 平台账号 (string query )
     * password 平台密码 (string query )
     * platformUrl 平台地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/study/adultCourseTable/updatePlatformInfo", p, c),
  },
  adultCourseTable_upload: {
    /*
     * 导入
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/ems/study/adultCourseTable/upload", p, c),
  },
};
